export default {
  bookOnline: '19122018-152801-0003',
  needHelpBooking: '19122018-152801-0004',
  call: '02062016-072326-8813',
  onDemandWorkspace: '28102025-085406-0002',
  needHelp: '05092025-113006-0001',
  goBack: '21022019-105513-0010',
  stepOfSteps: '08102025-095301-3977',
  previous: '01092015-144404-9535',
};

